<template>
  <div v-if="$ability.can('read', 'CashFlow')">
    <div class="p-col-12" style="width: 100%; padding: 0">
      <CashFlowTabs></CashFlowTabs>
    </div>
    <div class="p-grid" style="margin-top: 1px">
      <div class="p-col-12 p-md-4" v-if="$ability.can('write', 'CashFlow')">
        <Card v-show="!loading">
          <template v-slot:title>Nova Categoria</template>
          <template v-slot:content>
            <CashFlowCategoryForm
              ref="form"
              @save-start="loadingSave = true"
              @save-end="loadingSave = false"
              @save-success="onSaved()"
            ></CashFlowCategoryForm>
          </template>
          <template v-slot:footer>
            <div class="p-grid p-jc-end">
              <div style="padding-right: 8px">
                <Button
                  label="Cancelar"
                  class="p-button-outlined p-mr-2"
                  @click="$refs.form.reset()"
                />
                <AppButton
                  label="Salvar"
                  @click="$refs.form.save()"
                  :loading="loadingSave"
                />
              </div>
            </div>
          </template>
        </Card>
      </div>
      <div class="p-col-12 p-md-8">
        <Card>
          <template v-slot:title>Categorias</template>
          <template v-slot:content>
            <CashFlowCategoryTable ref="list"></CashFlowCategoryTable>
          </template>
        </Card>
      </div>
    </div>
  </div>
  <AppPermissionAlert v-else />
</template>

<script>
import CashFlowCategoryForm from './components/CashFlowCategoryForm.vue';
import CashFlowCategoryTable from './components/CashFlowCategoryTable.vue';
import CashFlowTabs from './components/CashFlowTabs.vue';

export default {
  name: 'CashFlowCategory',
  components: {
    CashFlowCategoryForm,
    CashFlowTabs,
    CashFlowCategoryTable,
  },
  data() {
    return {
      loading: false,
      loadingSave: false,
    };
  },
  methods: {
    onSaved() {
      this.$refs.form.reset();
      this.$refs.list.fetchList();
    },
  },
};
</script>

<style>
</style>